// TeamPageSEO.tsx
import { useEffect } from "react";

function TeamPageSEO() {
  useEffect(() => {
    // 1. Page title
    document.title = "Akwid Labs | Hire Top Tech Engineering Talent from Sri Lanka - Build Army of Experts";

    // 2. Meta description
    const descriptionMeta = document.querySelector("meta[name='description']");
    if (descriptionMeta) {
      descriptionMeta.setAttribute(
        "content",
        "We know you face the problem of finding and hiring top tech talent for your startup or enterpriseIt not just cost huge amount of time and money but also a lot of effort to find the right talent. At Akwid Labs, we solve this problem by providing you access to our network of top-tier software engineers, AI experts, and cloud specialists from Sri Lanka. Build your dream tech team with us and accelerate your growth. Akwid Labs will resolve your problem of finding cost effective and high quality tech talent for your startup or enterprise."
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content =
        "We know you face the problem of finding and hiring top tech talent for your startup or enterprise. It not just cost huge amount of time and money but also a lot of effort to find the right talent. At Akwid Labs, we solve this problem by providing you access to our network of top-tier software engineers, AI experts, and cloud specialists from Sri Lanka. Build your dream tech team with us and accelerate your growth. Akwid Labs will resolve your problem of finding cost effective and high quality tech talent for your startup or enterprise.";
      document.head.appendChild(meta);
    }

    // 3. Canonical link
    const canonicalLink = document.querySelector("link[rel='canonical']");
    if (!canonicalLink) {
      const link = document.createElement("link");
      link.rel = "canonical";
      link.href = "https://akwidlabs.com/team";
      document.head.appendChild(link);
    }

    // 4. Open Graph
    const ogTags = [
      { property: "og:title", content: "Meet the Team | Akwid Labs" },
      {
        property: "og:description",
        content:
          "Meet the Akwid Labs team – AI & software experts from Sri Lanka helping startups and enterprises with software, cloud, and AI solutions.",
      },
      { property: "og:url", content: "https://akwidlabs.com/hire-tech-team" },
      { property: "og:image", content: "/Images/akwidlabscover.webp" },
    ];

    ogTags.forEach((tag) => {
      let element = document.querySelector(`meta[property='${tag.property}']`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("property", tag.property);
        document.head.appendChild(element);
      }
      element.setAttribute("content", tag.content);
    });

    // 5. Twitter Card
    const twitterTags = [
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Meet the Team | Akwid Labs" },
      {
        name: "twitter:description",
        content:
          "Meet the Akwid Labs team – AI & software experts from Sri Lanka helping startups and enterprises with software, cloud, and AI solutions.",
      },
      { name: "twitter:image", content: "/Images/akwidlabscover.webp" },
      { name: "twitter:image:alt", content: "Akwid Labs Team" },
    ];

    twitterTags.forEach((tag) => {
      let element = document.querySelector(`meta[name='${tag.name}']`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", tag.name);
        document.head.appendChild(element);
      }
      element.setAttribute("content", tag.content);
    });

    // 6. JSON-LD structured data for Organization & Team
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Akwid Labs",
      "url": "https://akwidlabs.com/hire-tech-team",
      "logo": "/logo192.png",
      "sameAs": [
        "https://www.linkedin.com/company/akwidlabs",
        "https://twitter.com/akwidlabs",
        "https://www.facebook.com/akwidlabs"
      ],
      "member": [
        {
          "@type": "Person",
          "name": "Lakindu Widuranga Alwis",
          "jobTitle": "CEO & Chief Architect",
          "url": "https://akwidlabs.com/about"
        }
        // Add other key team members here
      ]
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}

// consulting 
function ConsultingPageSEO() {
  useEffect(() => {
    const pageUrl = "https://akwidlabs.com/consulting";

    // 1. Page title
    document.title =
      "Akwid Labs | End to End Consulting for Your Technology Growth by Consultants with Years of Experience in AI, Software, and Cloud Solutions";

    // 2. Meta description
    const descriptionMeta = document.querySelector("meta[name='description']");
    const descriptionContent =
      "Akwid Labs provides AI-driven software consulting and cloud solutions for startups, SMEs, and enterprises from Sri Lanka. Grow your business with expert guidance.";
    if (descriptionMeta) {
      descriptionMeta.setAttribute("content", descriptionContent);
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = descriptionContent;
      document.head.appendChild(meta);
    }

    // 3. Canonical link
    let canonical = document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    (canonical as HTMLLinkElement).href = pageUrl;

    // 4. Open Graph
    const ogTags = [
      { property: "og:title", content: "AI & Software Consulting | Akwid Labs" },
      { property: "og:description", content: descriptionContent },
      { property: "og:url", content: pageUrl },
      { property: "og:image", content: "/Images/akwidlabsconsulting.webp" },
    ];

    ogTags.forEach((tag) => {
      let element = document.querySelector(`meta[property='${tag.property}']`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("property", tag.property);
        document.head.appendChild(element);
      }
      element.setAttribute("content", tag.content);
    });

    // 5. Twitter Card
    const twitterTags = [
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "AI & Software Consulting | Akwid Labs" },
      { name: "twitter:description", content: descriptionContent },
      { name: "twitter:image", content: "/Images/akwidlabsconsulting.webp" },
      { name: "twitter:image:alt", content: "Akwid Labs Consulting" },
    ];

    twitterTags.forEach((tag) => {
      let element = document.querySelector(`meta[name='${tag.name}']`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", tag.name);
        document.head.appendChild(element);
      }
      element.setAttribute("content", tag.content);
    });

    // 6. JSON-LD for Organization + Services
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Akwid Labs",
      "url": pageUrl,
      "logo": "/logo192.png",
      "sameAs": [
        "https://www.linkedin.com/company/akwidlabs",
        "https://twitter.com/akwidlabs",
        "https://www.facebook.com/akwidlabs"
      ],
      "department": [
        {
          "@type": "Organization",
          "name": "Consulting Services",
          "url": pageUrl,
          "description": descriptionContent,
          "serviceType": [
            "AI Strategy Consulting",
            "Cloud Solutions",
            "Software Architecture Design",
            "Startup & Enterprise Software Advisory"
          ]
        }
      ]
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}

function EngineeringPageSEO() {
  useEffect(() => {
    const pageUrl = "https://akwidlabs.com/engineering";

    // 1. Title
    document.title =
      "Akwid Labs | Engineering Excellence in AI, FinTech & Scalable Software Systems";

    // 2. Meta description
    const descriptionContent =
      "Akwid Labs delivers engineering excellence in AI, FinTech, and scalable software systems. Build reliable, high-performance products with our expert engineering team.";

    const descriptionMeta = document.querySelector("meta[name='description']");
    if (descriptionMeta) {
      descriptionMeta.setAttribute("content", descriptionContent);
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = descriptionContent;
      document.head.appendChild(meta);
    }

    // 3. Canonical
    let canonical = document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = pageUrl;

    // 4. Open Graph
    const ogTags = [
      { property: "og:title", content: "Engineering Excellence | Akwid Labs" },
      { property: "og:description", content: descriptionContent },
      { property: "og:url", content: pageUrl },
      { property: "og:image", content: "/Images/akwidlabsengineering.webp" },
    ];

    ogTags.forEach((tag) => {
      let element = document.querySelector(`meta[property='${tag.property}']`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("property", tag.property);
        document.head.appendChild(element);
      }
      element.setAttribute("content", tag.content);
    });

    // 5. Twitter
    const twitterTags = [
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Engineering Excellence | Akwid Labs" },
      { name: "twitter:description", content: descriptionContent },
      { name: "twitter:image", content: "/Images/akwidlabsengineering.webp" },
      { name: "twitter:image:alt", content: "Akwid Labs Engineering" },
    ];

    twitterTags.forEach((tag) => {
      let element = document.querySelector(`meta[name='${tag.name}']`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", tag.name);
        document.head.appendChild(element);
      }
      element.setAttribute("content", tag.content);
    });

    // 6. JSON-LD (Service-based)
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Akwid Labs",
      "url": pageUrl,
      "logo": "/logo192.png",
      "sameAs": [
        "https://www.linkedin.com/company/akwidlabs",
        "https://twitter.com/akwidlabs",
        "https://www.facebook.com/akwidlabs"
      ],
      "makesOffer": [
        {
          "@type": "Service",
          "name": "AI Engineering",
          "description": "Design and development of AI-powered systems and applications."
        },
        {
          "@type": "Service",
          "name": "FinTech Engineering",
          "description": "Secure and scalable financial technology solutions."
        },
        {
          "@type": "Service",
          "name": "Cloud & Scalable Systems",
          "description": "High-performance cloud infrastructure and distributed systems."
        }
      ]
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}

function AiAndDataSEO() {
  useEffect(() => {
    const pageUrl = "https://www.akwidlabs.com/ai-and-data";

    // 1. Title
    document.title =
      "Akwid Labs | AI & Data Engineering Services for Scalable, Production-Ready Solutions";

    // 2. Meta description
    const descriptionContent =
      "Akwid Labs specializes in AI and data engineering, building scalable, production-ready systems. From data pipelines to custom AI models, we turn raw data into real business value.";

    const descriptionMeta = document.querySelector("meta[name='description']");
    if (descriptionMeta) {
      descriptionMeta.setAttribute("content", descriptionContent);
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = descriptionContent;
      document.head.appendChild(meta);
    }

    // 3. Canonical
    let canonical = document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = pageUrl;

    // 4. Open Graph
    const ogTags = [
      { property: "og:title", content: "AI & Data Engineering | Akwid Labs" },
      { property: "og:description", content: descriptionContent },
      { property: "og:url", content: pageUrl },
      { property: "og:image", content: "/Images/akwidlabs-ai-data.webp" },
    ];

    ogTags.forEach((tag) => {
      let element = document.querySelector(`meta[property='${tag.property}']`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("property", tag.property);
        document.head.appendChild(element);
      }
      element.setAttribute("content", tag.content);
    });

    // 5. Twitter
    const twitterTags = [
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "AI & Data Engineering | Akwid Labs" },
      { name: "twitter:description", content: descriptionContent },
      { name: "twitter:image", content: "/Images/akwidlabs-ai-data.webp" },
      { name: "twitter:image:alt", content: "Akwid Labs AI & Data Engineering" },
    ];

    twitterTags.forEach((tag) => {
      let element = document.querySelector(`meta[name='${tag.name}']`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", tag.name);
        document.head.appendChild(element);
      }
      element.setAttribute("content", tag.content);
    });

    // 6. JSON-LD (Service-focused)
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Akwid Labs",
      "url": pageUrl,
      "logo": "/logo192.png",
      "sameAs": [
        "https://www.linkedin.com/company/akwidlabs",
        "https://twitter.com/akwidlabs",
        "https://www.facebook.com/akwidlabs"
      ],
      "makesOffer": [
        {
          "@type": "Service",
          "name": "AI Development",
          "description": "Custom AI model development, training, and deployment."
        },
        {
          "@type": "Service",
          "name": "Data Engineering",
          "description": "Design and implementation of scalable data pipelines and architectures."
        },
        {
          "@type": "Service",
          "name": "Machine Learning Systems",
          "description": "Production-ready ML systems integrated into real-world applications."
        }
      ]
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}

function ContactPageSEO() {
  useEffect(() => {
    const pageUrl = "https://akwidlabs.com/contacts";

    // 1. Title
    document.title =
      "Contact Akwid Labs | AI, FinTech & Software Consulting";

    // 2. Meta description
    const descriptionContent =
      "Contact Akwid Labs for AI, FinTech, and software solutions. Talk to our team about your project, get expert advice, and start building scalable technology.";

    const descriptionMeta = document.querySelector("meta[name='description']");
    if (descriptionMeta) {
      descriptionMeta.setAttribute("content", descriptionContent);
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = descriptionContent;
      document.head.appendChild(meta);
    }

    // 3. Canonical
    let canonical = document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = pageUrl;

    // 4. Open Graph
    const ogTags = [
      { property: "og:title", content: "Contact Akwid Labs" },
      { property: "og:description", content: descriptionContent },
      { property: "og:url", content: pageUrl },
      { property: "og:image", content: "/Images/akwidlabscontact.webp" },
    ];

    ogTags.forEach((tag) => {
      let element = document.querySelector(`meta[property='${tag.property}']`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("property", tag.property);
        document.head.appendChild(element);
      }
      element.setAttribute("content", tag.content);
    });

    // 5. Twitter
    const twitterTags = [
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Contact Akwid Labs" },
      { name: "twitter:description", content: descriptionContent },
      { name: "twitter:image", content: "/Images/akwidlabscontact.webp" },
    ];

    twitterTags.forEach((tag) => {
      let element = document.querySelector(`meta[name='${tag.name}']`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", tag.name);
        document.head.appendChild(element);
      }
      element.setAttribute("content", tag.content);
    });

    // 6. JSON-LD (FAQ for search visibility)
    const faqJsonLd = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "How can I contact Akwid Labs?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can contact Akwid Labs through our website contact form or reach out via email to discuss your project."
          }
        },
        {
          "@type": "Question",
          "name": "What services can I discuss with Akwid Labs?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can discuss AI development, software engineering, cloud solutions, FinTech systems, and consulting services."
          }
        },
        {
          "@type": "Question",
          "name": "Do you work with international clients?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Akwid Labs works with startups, SMEs, and enterprises globally."
          }
        },
        {
          "@type": "Question",
          "name": "How quickly can I get a response?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our team usually responds within 24 hours after receiving your inquiry."
          }
        },
        {
          "@type": "Question",
          "name": "Can I request a consultation before starting a project?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we offer consultations to understand your needs and how we can best assist you."
          }
        },
        {
          "@type": "Question",
          "name": "What information should I provide when contacting you?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Please provide a brief overview of your project, your goals, and any specific questions or areas where you need assistance."
          }
        },
          {
          "@type": "Question",
          "name": "What's the email address to reach Akwid Labs?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can email us at hello@akwidlabs.com for general inquiries."
          }
        },
          {
          "@type": "Question",
          "name": "What the countries Akwid Labs works with?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Akwid Labs works with clients from all around the world, including the US, UK, Canada, Australia, and many more."
          }
        }
      ]
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(faqJsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}

export { TeamPageSEO, ConsultingPageSEO, EngineeringPageSEO, AiAndDataSEO, ContactPageSEO };